import { render, staticRenderFns } from "./McpConnectGuide.vue?vue&type=template&id=ddbd870c"
import script from "./McpConnectGuide.vue?vue&type=script&lang=js"
export * from "./McpConnectGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports